export enum HttpMethod {
  DELETE = "DELETE",
  PATCH = "PATCH",
  POST = "POST",
  PUT = "PUT",
  GET = "GET",
}

export type HttpConfig = {
  headers?: Record<string, string>;
  params?: Record<string, string | number | boolean>;
  method?: HttpMethod;
  body?: BodyInit;
  baseURL?: string;
};

export interface Http {
  isPerimeterexError(error: unknown): Promise<boolean>;
  request(url: string, config?: HttpConfig): Promise<string>;
}
